(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carrusel-cuidador"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carrusel-cuidador')) {
    class CarruselCuidador extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cc__track');
        this.dots = this.querySelector('.cc__dots');
        this.pauseButton = this.querySelector('.cc__pause');
        if (!this.track) return;

        this.abort = new AbortController();
        const options = { signal: this.abort.signal };

        // Una foto que no existe en Contenido > Archivos se saca del carrusel.
        for (const img of this.querySelectorAll('.cc__img')) {
          if (img.complete && img.naturalWidth === 0) this.dropSlide(img);
          else img.addEventListener('error', () => this.dropSlide(img), { ...options, once: true });
        }
        this.refreshSlides();
        if (this.hidden) return;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = this.reducedMotion;
        this.hovered = false;
        this.focused = false;
        this.touching = false;
        this.inView = false;
        this.index = 0;
        this.positions = 0;

        this.querySelector('.cc__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('.cc__arrow--next')?.addEventListener('click', () => this.go(this.index + 1), options);
        this.pauseButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        }, options);

        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(/** @type {Node|null} */ (event.relatedTarget));
          this.sync();
        }, options);
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.touching = true;
          this.sync();
        }, options);
        for (const type of ['pointerup', 'pointercancel']) {
          window.addEventListener(type, () => {
            if (!this.touching) return;
            this.touching = false;
            this.sync();
          }, options);
        }
        this.addEventListener('keydown', (event) => this.onKeydown(event), options);
        this.track.addEventListener('scroll', () => this.onScroll(), { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.sync(), options);

        this.resizeObserver = new ResizeObserver(() => this.buildDots());
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.sync();
        }, { threshold: 0.35 });
        this.intersectionObserver.observe(this);

        this.buildDots();
        this.sync();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearInterval(this.timer);
        this.timer = undefined;
      }

      /** @param {HTMLImageElement} img */
      dropSlide(img) {
        img.closest('.cc__slide')?.remove();
        if (this.slides) {
          this.refreshSlides();
          this.positions = 0;
          if (!this.hidden && this.slides.length > 1) this.buildDots();
        }
      }

      refreshSlides() {
        this.slides = [...this.querySelectorAll('.cc__slide')];
        this.hidden = this.slides.length === 0;
        this.toggleAttribute('data-single', this.slides.length < 2);
        if (this.slides.length < 2) {
          clearInterval(this.timer);
          this.timer = undefined;
        }
        this.slides.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} de ${this.slides.length}`));
      }

      get isRtl() {
        return getComputedStyle(this).direction === 'rtl';
      }

      /** Distancia entre el inicio de una foto y la siguiente. */
      get step() {
        const first = this.slides[0].getBoundingClientRect();
        const second = this.slides[1].getBoundingClientRect();
        return Math.abs(second.left - first.left) || 1;
      }

      /** Cantidad de posiciones de arranque posibles según cuántas fotos entran. */
      countPositions() {
        const perView = Math.max(1, Math.round((this.track.clientWidth + 1) / this.step));
        return Math.max(1, this.slides.length - perView + 1);
      }

      buildDots() {
        if (this.slides.length < 2) return;
        const positions = this.countPositions();
        if (positions === this.positions) return;
        this.positions = positions;
        this.dots.replaceChildren();
        for (let i = 0; i < positions; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cc__dot';
          dot.setAttribute('aria-label', `Ir a la foto ${i + 1} de ${this.slides.length}`);
          dot.addEventListener('click', () => this.go(i), { signal: this.abort.signal });
          this.dots.append(dot);
        }
        this.onScroll();
      }

      onScroll() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const scrolled = Math.abs(this.track.scrollLeft);
          const max = this.track.scrollWidth - this.track.clientWidth;
          const index = scrolled >= max - 2 ? this.positions - 1 : Math.round(scrolled / this.step);
          this.index = Math.min(Math.max(index, 0), this.positions - 1);
          [...this.dots.children].forEach((dot, i) => {
            if (i === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        });
      }

      /** @param {number} target */
      go(target) {
        if (this.slides.length < 2 || !this.positions) return;
        const index = (target + this.positions) % this.positions;
        const left = index * this.step * (this.isRtl ? -1 : 1);
        this.track.scrollTo({ left, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        this.index = index;
        this.restartTimer();
      }

      /** @param {KeyboardEvent} event */
      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const forward = (event.key === 'ArrowRight') !== this.isRtl;
        this.go(this.index + (forward ? 1 : -1));
      }

      get shouldPlay() {
        return this.slides.length > 1 && !this.userPaused && !this.hovered && !this.focused && !this.touching && this.inView && !document.hidden;
      }

      sync() {
        const playing = this.shouldPlay;
        if (playing && !this.timer) this.restartTimer();
        if (!playing && this.timer) {
          clearInterval(this.timer);
          this.timer = undefined;
        }
        // Lectores de pantalla: anunciar cambios solo cuando no pasa sola.
        this.track.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (this.pauseButton) {
          this.pauseButton.dataset.state = this.userPaused ? 'paused' : 'playing';
          this.pauseButton.setAttribute(
            'aria-label',
            this.userPaused ? 'Reanudar el pase automático de fotos' : 'Pausar el pase automático de fotos'
          );
        }
      }

      restartTimer() {
        clearInterval(this.timer);
        this.timer = undefined;
        if (!this.shouldPlay) return;
        this.timer = setInterval(() => this.go(this.index + 1), 5000);
      }
    }

    customElements.define('carrusel-cuidador', CarruselCuidador);
  }
  } catch(e) { console.error(e); }
})();

})();
